import { AnyAction } from "redux";
import {
  LOGOUT_SUCCESS,
  LOGIN_COMPLETE,
  UPDATE_SUBSCRIPTION_SUCCESS,
  ACCEPT_TERMS_SUCCESS,
  ACCEPT_TERMS,
} from "../../common/redux/actions";
import { AuthState, UserType } from "../../common/redux/AuthState";
import { AAD_ACQUIRED_ID_TOKEN_SUCCESS, AAD_LOGIN_SUCCESS } from "./actions";

export const reducer = (
  state: AuthState = {
    user: null,
    loginStatus: "LOGGING_IN",
  },
  action: AnyAction
) => {
  const { type, payload } = action;
  switch (type) {
    case AAD_LOGIN_SUCCESS:
      // the initial AD success action is handled in the sagas, but we could record
      //  the response object here if required.
      return state;
    case AAD_ACQUIRED_ID_TOKEN_SUCCESS:
      if (!state.user) {
        // not ready yet, this is the AAD_ACQUIRED_ID_TOKEN_SUCCESS that happens just before AAD_LOGIN_SUCCESS
        return state;
      }
      return {
        ...state,
        user: { ...state.user, token: payload.idToken.rawIdToken },
      };
    case LOGIN_COMPLETE:
      // now the user endpoint auth has happened, we have access to both auth responses
      const { aadResponse, userResponse } = payload;
      const upn: string = aadResponse.account.userName;
      const user = {
        upn,
        displayName: aadResponse.account.name,
        token: aadResponse.jwtIdToken,
        roles: userResponse.userRoles,
        userType: userResponse.userType,
        subscribeToEmails: userResponse.subscribeToEmails,
        acceptedTerms: userResponse.acceptedTerms,
        org: userResponse.awardingOrg || {
          name: userResponse.userType === UserType.Ofqual ? "OFQUAL" : "CCEA",
        },
        experimentalFeatures: userResponse.userExperimentalFeatures
      };
      return { ...state, user, loginStatus: "LOGGED_IN" };
    case LOGOUT_SUCCESS:
      return { ...state, user: null, loginStatus: "LOGGED_OUT" };
    case UPDATE_SUBSCRIPTION_SUCCESS:
      const { subscribeToEmails } = payload;
      return { ...state, user: { ...state.user, subscribeToEmails } };
    case ACCEPT_TERMS:
      return { ...state, user: { ...state.user, acceptedTerms: true } };
    default:
      return state;
  }
};
